export default [
  {
    path: '/social-booking-slots',
    name: 'social-booking-slots',
    component: () => import('@/views/socialBookingSlots/SocialBookingSlots.vue'),
    meta: {
      protected: true,
      pageTitle: 'Booking slots',
      offsite: false,
      breadcrumb: [
        {
          text: 'Booking slots',
          active: true,
        },
      ],
    },
  },
  {
    name: 'create-social-booking-slot',
    path: '/social-booking-slots/create',
    meta: {
      protected: true,
    },
    component: () => import('@/views/socialBookingSlots/CreateSocialBookingSlot.vue'),
  },
  {
    name: 'update-social-booking-slot',
    path: '/social-booking-slots/:bookingSlotId/update',
    meta: {
      protected: true,
    },
    component: () => import('@/views/socialBookingSlots/UpdateSocialBookingSlot.vue'),
  },
]
